import {ModificationInfo} from './ModificationInfo';

export class Entity {

  public id?: string;
  public modificationInfo?: ModificationInfo;
}
